import React, { useState } from 'react';
import "./index.less"
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip as AntTooltip } from 'antd';

export default function Tooltip(props) {
    const { title, style } = props;
    return (
        <React.Fragment>
            {(!!title) && <span style={{ marginLeft: "5px", cursor: "help", color: "rgba(0,0,0,0.45)", ...style }}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}>
                <AntTooltip title={title}>
                    <QuestionCircleOutlined />
                </AntTooltip>
            </span>}
        </React.Fragment>
    )
}